import React, { ReactElement, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { GroupId } from 'services/groups/types';
import { AppState } from 'services/types';
import { makeSelectGroupTimesheetAlreadyExist } from './selectors';

export interface Props {
    fallback?: ReactElement | ReactNode;
    children?: ReactElement | ReactNode;
    startDate?: string;
    groupId?: GroupId;
}

export default function GroupTimesheetAlreadyExistGate(
    props: Props
): ReactElement | null {
    const { children, fallback } = props;

    const groupTimesheetAlreadyExist = useSelector((state: AppState) =>
        makeSelectGroupTimesheetAlreadyExist()(state, props)
    );

    if (groupTimesheetAlreadyExist) {
        return <React.Fragment>{children}</React.Fragment>;
    }

    if (fallback) {
        return <React.Fragment>{fallback}</React.Fragment>;
    }

    return null;
}
